/**
 * LiveEntryCheckBoundary — le test du matériel isolé : s'il tombe, on perd sa vérification, pas son live.
 * L'ancien `PreCallCheckBoundary` (`common/liveMode/precall/`), repris : une exception du test (son rendu,
 * son moteur, ses effets) rend `fallback` — la page sans test, l'entrée pleine — et part à Bugsnag par la
 * télémétrie du précall, au lieu de démonter toute l'app. Elle ne protège que ce qui est monté DEDANS : le
 * masteur y monte son test (`tutor/PreCall/TutorPreCallScreen`) ; l'élève, dont le moteur vit en tête de
 * l'écran, ne l'a pas encore (issue de suite du précall de l'élève).
 */
import React from "react"

import { createTelemetry, type TelemetryRole } from "../../../../../../engine/shared/telemetry"

type Props = { role: TelemetryRole; fallback: React.ReactNode; children: React.ReactNode }

export class LiveEntryCheckBoundary extends React.Component<Props, { failed: boolean }> {
    state = { failed: false }

    static getDerivedStateFromError() {
        return { failed: true }
    }

    componentDidCatch(error: unknown) {
        createTelemetry("precall", { role: this.props.role }).error("check_crashed", error)
    }

    render() {
        return this.state.failed ? this.props.fallback : this.props.children
    }
}
